import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["containerProps", "prefixIcon", "prefixIconColour", "iconRatio", "required", "disabled", "dropDownIconHideProps", "children"];

var _templateObject, _templateObject2, _templateObject3;

import React from "react";
import { border, color, compose, focusBorderColorProp, hoverColorProp, layout, space, styled, themeGet } from "@catchoftheday/theme";
import { Flex } from "../Flex";
import { Hide } from "../Hide";
import { IconDownArrow } from "../Icon";
import { jsx as ___EmotionJSX } from "@emotion/react";
var styleProps = compose(layout, border, space, color);
var BaseSelect = styled.select(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding-right: ", ";\n  color: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  font-weight: inherit;\n  line-height: inherit;\n  appearance: none;\n  -ms-appearance: none; /* Edge */\n  cursor: pointer;\n  vertical-align: middle;\n  /** IE11 */\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:focus {\n    outline: 0;\n    border-radius: 0;\n    ", "\n  }\n\n  &:hover:enabled {\n    ", "\n    ~ span > svg {\n      ", "\n    }\n  }\n\n  ", "\n\n  ", "\n"])), themeGet("space.5"), focusBorderColorProp, hoverColorProp, hoverColorProp, function (prop) {
  return prop.maxWidth && "\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;";
}, styleProps);
BaseSelect.defaultProps = {
  py: 3,
  border: 1,
  borderRadius: "4px",
  borderColor: "ui.borderColor",
  focusBorderColor: "secondary"
};
var IconWrapperAfter = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(50% - 0.75em);\n  right: 3px;\n  padding-right: 10px;\n  pointer-events: none;\n"])));
var IconWrapperBefore = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: calc(50% - 0.75em);\n  left: 0.75em;\n"])));
export var Select = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var containerProps = _ref.containerProps,
      PrefixIcon = _ref.prefixIcon,
      prefixIconColour = _ref.prefixIconColour,
      iconRatio = _ref.iconRatio,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      dropDownIconHideProps = _ref.dropDownIconHideProps,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return ___EmotionJSX(Flex, _extends({
    display: "inline-flex",
    position: "relative",
    alignItems: "center"
  }, containerProps), ___EmotionJSX(BaseSelect, _extends({
    ref: ref,
    "aria-required": required,
    "aria-disabled": disabled,
    required: required,
    disabled: disabled,
    width: containerProps !== null && containerProps !== void 0 && containerProps.width ? "100%" : "auto",
    pl: PrefixIcon ? "2.5rem" : "0.75rem",
    pr: "35px",
    color: "secondary",
    bg: "white"
  }, otherProps), children), ___EmotionJSX(Hide, dropDownIconHideProps, ___EmotionJSX(IconWrapperAfter, null, ___EmotionJSX(IconDownArrow, {
    width: "0.8em",
    height: "0.4em",
    color: disabled ? "typography.inactive" : "inherit",
    title: "select drop down arrow"
  }))), PrefixIcon && ___EmotionJSX(IconWrapperBefore, null, ___EmotionJSX(PrefixIcon, {
    height: "1.5em",
    width: "".concat(1.5 * (iconRatio || 0.5), "em"),
    color: disabled ? "typography.inactive" : prefixIconColour || "inherit"
  })));
});
Select.displayName = "Select";
Select.defaultProps = {
  containerProps: {
    color: "typography.text"
  },
  dropDownIconHideProps: {}
};
export default Select;